// THIS FILE IS AUTO-GENERATED DURING BUILD
export const APP_VERSION = "2.0.530";
export const APP_BUILD_DATE = "25/10/2026, 13:59:23";
